// ============================================================
// AWS Cognito Configuration
// credentials from the AWS Console.
// ============================================================

export const awsExports = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_iZ9dM5rsE',
      userPoolClientId: '9qk5887kshukl7iuoeit1a4f7',
      loginWith: {
        email: true,
        // OAuth must be nested here (not at Cognito root level) for Amplify v6.
        // Domain must NOT include https:// — Amplify adds the scheme itself.
        // redirectSignIn / redirectSignOut must be arrays.
        oauth: {
          domain: 'us-east-1iz9dm5rse.auth.us-east-1.amazoncognito.com',
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: ['http://localhost:4200/panel/subscription', 'https://clientes.eldiario.com.co/panel/subscription'],
          redirectSignOut: ['http://localhost:4200/login', 'https://clientes.eldiario.com.co/login'],
          responseType: 'code',
        },
      },
    },
  },
};
